import * as signalR from '@microsoft/signalr';
import { SignalRClient } from '@/core/signalR/signalR.client';

const SIGNALR_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/signalRHub' : 'https://titans-league.org/signalr/hub';
const SIGNALR_LOGLEVEL = process.env.NODE_ENV === 'development' ? signalR.LogLevel.Information : signalR.LogLevel.None;

export class SignalRService extends SignalRClient {
    constructor() {
        super(SIGNALR_URL, SIGNALR_LOGLEVEL);
    }
}

export default new SignalRService();
